import { callApiToServer, putApiToServer } from '../callApi';

export async function updateSalesUser(
        authtoken,   
        payload,
        id
){
    try {
        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "authorization": "Berear " + authtoken
        };

        let body = JSON.stringify(payload);

        let endUrl = `v1/auth/sales/edit/${id}`;

        let responseData = await putApiToServer(body, header, "PUT", endUrl);

        return responseData;

    } catch (err) {
        throw err;
    }
}
